/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import DSFormEdit from './DSFormEdit';
import DSFormView from './DSFormView';
import DSRequestFormService from '../../../../services/DSRequestForm.service';

export default function DSInformation({
    data,
    domainId,
    newStatus,
    getDSInformation,
}) {
    const [editMode, setEditMode] = useState(false);
    const [customize, setCustomize] = useState();
    const [imageFile, setImageFile] = useState();
    const [docFile, setDocFile] = useState();
    const [fileTask, setFileList] = useState([]);

    useEffect(() => {
        async function getCustomize() {
            const { data } = await DSRequestFormService.getCustomize(domainId);
            setCustomize({
                ...data?.resultData,
                ...data?.resultData?.customizeForm,
            });
        }

        if (domainId) {
            getCustomize();
        }
    }, [domainId]);

    useEffect(() => {
        getDSInformation();
    }, [editMode]);

    useEffect(() => {
        const image = data?.evidenceInformation?.filesImage;

        const doc = data?.evidenceInformation?.filesDoc;
        const allFile = doc?.concat(image);
        setImageFile(image);
        setDocFile(doc);
        setFileList(allFile);
    }, [data]);

    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
            {editMode ? (
                <DSFormEdit
                    item={data}
                    domainId={domainId}
                    customize={customize}
                    setEditMode={setEditMode}
                    editMode={editMode}
                    imageFile={imageFile}
                    setImageFile={setImageFile}
                    docFile={docFile}
                    setDocFile={setDocFile}
                    fileTask={fileTask}
                    setFileList={setFileList}
                    getDSInformation={getDSInformation}
                />
            ) : (
                <DSFormView
                    item={data}
                    newStatus={newStatus}
                    domainId={domainId}
                    customize={customize}
                    setEditMode={setEditMode}
                    editMode={editMode}
                    imageFile={imageFile}
                    setImageFile={setImageFile}
                    docFile={docFile}
                    setDocFile={setDocFile}
                    fileTask={fileTask}
                    setFileList={setFileList}
                    getDSInformation={getDSInformation}
                />
            )}
        </div>
    );
}
